<template>
  <div>
    <div class="row grid-row align-items-center mb-10">
      <div class="col-11 text-right px-0">
        <span class="link-text pointer" v-if="editDebitAdjust" @click="editDebit=true">
          <svgicon name="icon-debit" width="10" height="8" /> Debit Adjustment
        </span>
      </div>
    </div>
    <div v-for="(row,index) in columns" :key="index">
      <div class="row grid-row align-items-center">
        <div class="col-8 grid-title">{{row.label}}</div>
        <div class="col-3 grid-count">
          <input class="input-field"
            v-model="transporterDebit[row.column]"
            :disabled="row.readOnly" 
            @keydown="preventDefault($event)"
            @keyup="preventDefault($event)" />
        </div>
      </div>
    </div>
    <div class="row grid-row align-items-center" :class="{ 'activeblock': editDebit }">
      <div class="col-8 grid-title">Debit Adjustment</div>
      <div class="col-3 grid-count">
        <input class="input-field text-red"
          type="number"
          v-model="debitAdjustment"
          :disabled="!editDebit"
          @keydown="preventDefault($event)"
          @keyup="preventDefault($event)" />
      </div>
    </div>
    <div class="row align-items-center mb-10">
      <div class="col-8 grid-title resulttext">Total Amount</div>
      <div class="col-3 resultvalue grid-count">
        {{getTotal}}
      </div>
    </div>
    <div class="row">
      <div class="col-11 text-right px-0 mb-10" v-if="editDebit">
        <Button type="text" size="mini" @click="$emit('cancel')">Cancel</Button>
        <Button type="primary" size="mini" @click="saveTransporterDebit">Save</Button>
      </div>
    </div>
  </div>
</template>
<script>
import columns from '@common/constants/transporterDebitConstants';

export default {
  props: {
    transporterDebit: {
      type: Object,
      required: true,
    },
    editDebitAdjust: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns,
      editDebit: false,
      debitAdjustment: 0,
    };
  },
  created() {
    this.debitAdjustment = this.transporterDebit.transporter_debit_adjust || 0;
  },
  computed: {
    getTotal() {
      let total = this.columns.reduce((acc,row) => {
        let value = this.transporterDebit[row.column] || 0;
        return acc += Number(value)
      }, 0);
      total -= Number(this.debitAdjustment);
      return Number(total).toFixed(2);
    },
  },
  methods: {
    preventDefault(event) {
      event.stopPropagation();
    },
    saveTransporterDebit() {
      if (this.getTotal < 0){
        this.$errorMessage({ message: this.$getErr('DEBIT_ADJUSTMENT_INVALID') });
      } else if(this.debitAdjustment < 0) {
        this.$errorMessage({ message: this.$getErr('DEBIT_ADJUSTMENT_NEGATIVE') });
      } else {
        const data = {
          debitAdjustment: Number(this.debitAdjustment),
          debitSubtotal: this.getTotal,
        };
        this.$emit('saveTransporterDebit',data);
      }
    },
  },
};
</script>
